import type { ArchiveDigitizationStatus } from '@type/archive.types'

export type AddArchiveRecordFormValues = {
  patient_id: string
  patient_name: string
  date_of_birth: string
  gender: string
  mrn: string
  folder_number: string
  date_range_start: string
  date_range_end: string
  digitization_status: ArchiveDigitizationStatus
  physical_location_name: string
  shelf: string
  column: string
  section: string
  facility_id: string
}

export const ARCHIVE_RECORD_STEPS = [
  { id: 1, label: 'Patient' },
  { id: 2, label: 'File Info' },
  { id: 3, label: 'Location & Ownership' },
  { id: 4, label: 'Review' }
] as const

export const DIGITIZATION_OPTIONS: { value: ArchiveDigitizationStatus; label: string }[] = [
  { value: 'physical_only', label: 'Physical Only' },
  { value: 'partially_scanned', label: 'Partially Scanned' },
  { value: 'fully_scanned', label: 'Fully Digitized' }
]

export const STEP_FIELDS: Record<number, (keyof AddArchiveRecordFormValues)[]> = {
  1: ['patient_id'],
  2: ['folder_number', 'date_range_start', 'date_range_end', 'digitization_status'],
  3: ['physical_location_name', 'shelf', 'column', 'section', 'facility_id']
}
